import React from "react";
import ReportPage from "./ReportPage";

export default function CoopReports() {
  return (
    <ReportPage
      title="Co-op & Other Deductions"
      subtitle="Co-operative and other deduction schedule."
      endpoint="/reports/statutory/coop"
      exportName="coop"
      summaryCards={[
        { key: "total_amount", label: "Total Amount", money: true },
        { key: "staff_count_on_page", label: "Staff Count" },
      ]}
      columns={[
        { key: "pf_no", label: "PF No" },
        { key: "fullname", label: "Name" },
        { key: "item", label: "Item" },
        { key: "amount", label: "Amount" },
      ]}
    />
  );
}
